// extracted by mini-css-extract-plugin
export default {"root":"QualityStatisticalGraph_root__t0zRf","list-button":"QualityStatisticalGraph_list-button__9Kint","chart":"QualityStatisticalGraph_chart__haecu"};